/**
 * StatusBadge — Online / Offline / Warning indicator.
 */

interface StatusBadgeProps {
  online: boolean;
  warning?: boolean;
}

export function StatusBadge({ online, warning }: StatusBadgeProps) {
  const variant = warning ? 'warning' : online ? 'online' : 'offline';
  const label = warning ? 'Warning' : online ? 'Online' : 'Offline';

  return (
    <span className={`badge badge--${variant}`}>
      <span className="badge-dot" />
      {label}
    </span>
  );
}
